import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/secondadmin/base.component';
import { ClientService } from 'src/app/services/clients/client.service';
import { MasterService } from 'src/app/services/master/master.service';

@Component({
  selector: 'app-list-reskinning',
  templateUrl: './list-reskinning.component.html',
  styleUrls: ['./list-reskinning.component.css']
})
export class ListReskinningComponent extends BaseComponent implements OnInit, OnDestroy {
  totalCount;
  currentUser: any;
  getCompanyobj: any = [];
  companyID: any = '';
  isSuperAdmin = false;
  reskinningObj: any[];
  themeObj: any;
  loading: boolean = false;
  private companySub: Subscription;

  constructor(
    private clientService: ClientService,
    private masterService: MasterService
  ) { super(); }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem('userData'));
    this.isSuperAdmin = String(this.currentUser.admin_customer_id) === '0';
    if (!this.isSuperAdmin) {
      this.getrskList(this.currentUser.admin_customer_id);
    }
    this.getCompany();
  }

  ngOnDestroy(): void {
    if (this.companySub) {
      this.companySub.unsubscribe();
    }
  }

  getCompany() {
    this.clientService.getBUCompanies().subscribe(data => {
      this.getCompanyobj = data.data || [];
      if (this.isSuperAdmin) {
        this.applyHeaderCompany();
        if (!this.companySub) {
          this.companySub = this.workingCompanyService.companyChange$.subscribe(() => {
            this.applyHeaderCompany();
          });
        }
      }
    }, error => {
    });
  }

  applyHeaderCompany() {
    const working = this.bindWorkingCompany(this.getCompanyobj);
    if (working) {
      if (String(this.companyID) !== String(working) || !this.reskinningObj) {
        this.getrskList(working);
      }
      return;
    }
    if (this.companyID) {
      this.companyID = '';
      this.reskinningObj = [];
      this.totalCount = 0;
    }
  }

  onCompanyChange(value?: any) {
    this.getrskList(value);
  }

  getrskList(id: any) {
    if (!id) {
      this.companyID = '';
      this.reskinningObj = [];
      this.totalCount = 0;
      return;
    }
    this.companyID = String(id);
    localStorage.setItem('companyId', this.companyID);
    this.ngxSpinnerService.show();
    this.loading = true;
    this.masterService.fetchReskinningByCompany(this.companyID).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.ngxSpinnerService.hide();
        this.reskinningObj = res;
        this.totalCount = this.reskinningObj.length;
      },
      error: (error: any) => {
        this.ngxSpinnerService.hide();
        this.reskinningObj = [];
        this.totalCount = 0;
        this.loading = false;
      }
    });
  }

  getReskinningDataByUserType(id: any) {
    localStorage.setItem('companyId', this.companyID);
    localStorage.setItem('rskAction', 'Edit');
    this.router.navigate(['/corporate/addnewreskinning'], { queryParams: { companyID: this.companyID, them_id: id } });
  }

  navigateToAdd() {
    localStorage.setItem('rskAction', 'Add');
    this.router.navigate(['/corporate/addnewreskinning']);
  }
}
